import { ClassroomsPage } from "@/pages/teacher/ClassroomsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/teacher/classrooms/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ClassroomsPage />;
}
